// extracted by mini-css-extract-plugin
module.exports = {"Component":"DataTableVoucher_Component__2fbVH"};